module.exports = __webpack_public_path__ + "media/images/icons/eye-058c2ec419cf1957a39b32ca06e1aa7a.svg";